import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=34471f8e&"
import script from "./ProductView.vue?vue&type=script&lang=js&"
export * from "./ProductView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports